import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box
} from '@mui/material';
import { useClientUiSettings } from '../../hooks/useClientUiSettings';

const AssessmentLauncher = ({
  isOpen,
  onClose,
  testName,
  testDescription,
  onStartAssessment,
  initiatedBy // 'ai' or 'therapist' or 'client_self'
}) => {
  const { roleLabel = 'AI Therapist' } = useClientUiSettings();

  if (!isOpen) {
    return null;
  }

  let title = "Assessment Suggested";
  let startButtonText = "Start Assessment";
  let introText = `The ${roleLabel} has suggested you complete the ${testName}.`;

  if (initiatedBy === 'therapist') {
    title = "Start Assessment";
    introText = `Your therapist has initiated the ${testName} for you.`;
  } else if (initiatedBy === 'client_self') {
    title = `Start ${testName}`;
    introText = `You are about to start the ${testName}.`;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        // Only the buttons decide. A click outside or Escape used to count as
        // "maybe later", so the AI was told the client had deferred an
        // assessment they had only dismissed (ST-20260910-0002).
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
      data-testid="assessment-modal"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {introText}
        </Typography>
        {testDescription && (
          <Box sx={{ mt: 2, p: 2, backgroundColor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>About this assessment:</Typography>
            <Typography variant="body2" color="text.secondary">
              {testDescription}
            </Typography>
          </Box>
        )}
        <Typography variant="body1" sx={{ mt: 2 }}>
          This can help provide a better understanding of your current experiences.
          Would you like to proceed?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {initiatedBy === 'ai' ? "Maybe Later" : "Cancel"}
        </Button>
        {initiatedBy === 'ai' && (
           <Button onClick={() => onClose('rejected')} color="warning"> 
           {/* 'rejected' could be a special value to log this explicit refusal */}
            No Thanks
          </Button>
        )}
        <Button onClick={onStartAssessment} variant="contained" color="primary">
          {startButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssessmentLauncher;
